import React from 'react'

const Flpkrt14 = () => {
    return (
        <div className='container'>
        <h1>Queue using Stacks</h1>
            <p> We are given a stack data structure with push and pop operations, the task is to implement a queue using instances of stack data structure and operations on them.</p>
            <p><strong>Solution (By making deQueue operation costly)</strong>In this method, in en-queue operation, the new element is entered at the top of stack1. In de-queue operation, if stack2 is empty then all the elements are moved to stack2 and finally top of stack2 is returned.&nbsp;</p>
            <pre className='containers'>{`enQueue(q,  x)
  1) Push x to stack1 (assuming size of stacks is unlimited).
Here time complexity will be O(1)

deQueue(q)
  1) If both stacks are empty then error.
  2) If stack2 is empty
       While stack1 is not empty, push everything from stack1 to stack2.
  3) Pop the element from stack2 and return it.
Here time complexity will be O(n)`}</pre>

        <div class="tabs">
           <input type="radio" name="tab" id="tab1" />
           <label for="tab1">CPP</label>
           <input type="radio" name="tab" id="tab2"/>
           <label for="tab2">Java </label>
           <input type="radio" name="tab" id="tab3"/>
           <label for="tab3">Python</label>
           <input type="radio" name="tab" id="tab3"/>
           <label for="tab4">C</label>
       
         
           <div class="tab-content-wrapper">
             <div id="tab-content-1" class="tab-content">
             <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// CPP program to implement Queue using</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// two stacks with costly deQueue()</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">Queue &#123;</code>
    </div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">stack&lt;</code><code class="color1 bold">int</code><code class="plain">&gt; s1, s2;</code>
    </div>
    <div class="line number8 index7 alt1">&nbsp;</div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Enqueue an item to the queue</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">enQueue(</code><code class="color1 bold">int</code>
        <code class="plain">x)</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Push item into the first stack</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s1.push(x);</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number15 index14 alt2">&nbsp;</div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Dequeue an item from the queue</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">deQueue()</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// if both stacks are empty</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s1.empty() &amp;&amp; s2.empty()) &#123;</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Q is empty"</code><code class="plain">;</code>
    </div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">exit</code><code class="plain">(0);</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number24 index23 alt1">&nbsp;</div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// if s2 is empty, move</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// elements from s1</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(s2.empty()) &#123;</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(!s1.empty()) &#123;</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s2.push(s1.top());</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s1.pop();</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number33 index32 alt2">&nbsp;</div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// return the top item from s2</code></div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">x = s2.top();</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">s2.pop();</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">x;</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number39 index38 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number40 index39 alt1">&nbsp;</div>
    <div class="line number41 index40 alt2"><code class="comments">// Driver code</code></div>
    <div class="line number42 index41 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number43 index42 alt2"><code class="plain">&#123;</code></div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Queue q;</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.enQueue(1);</code></div>
    <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.enQueue(2);</code></div>
    <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.enQueue(3);</code></div>
    <div class="line number48 index47 alt1">&nbsp;</div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; q.deQueue() &lt;&lt; </code><code class="string">'\n'</code><code
            class="plain">;</code></div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; q.deQueue() &lt;&lt; </code><code class="string">'\n'</code><code
            class="plain">;</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; q.deQueue() &lt;&lt; </code><code class="string">'\n'</code><code
            class="plain">;</code></div>
    <div class="line number52 index51 alt1">&nbsp;</div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number54 index53 alt1"><code class="plain">&#125;</code></div>
</div>
           </div>
             <div id="tab-content-2" class="tab-content">
             <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">/* Java Program to implement a queue using two stacks */</code></div>
    <div class="line number2 index1 alt1"><code
            class="comments">// Note that Stack class is used for Stack implementation</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword">import</code> <code
            class="plain">java.util.Stack;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="keyword">public</code> <code class="keyword">class</code> <code
            class="plain">NooB &#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* class of queue having two stacks */</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">class</code> <code class="plain">Queue &#123;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Stack&lt;Integer&gt; stack1;</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Stack&lt;Integer&gt; stack2;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Function to push an item to stack*/</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">push(Stack&lt;Integer&gt; top_ref, </code><code class="keyword">int</code> <code
            class="plain">new_data)</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Push the data onto the stack</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">top_ref.push(new_data);</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2">&nbsp;</div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Function to pop an item from stack*/</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">int</code> <code
            class="plain">pop(Stack&lt;Integer&gt; top_ref)</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/*If stack is empty then error */</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(top_ref.isEmpty()) &#123;</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Stack Underflow"</code><code
            class="plain">);</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.exit(</code><code class="value">0</code><code class="plain">);</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// pop the data from the stack</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">top_ref.pop();</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Function to enqueue an item to the queue</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">enQueue(Queue q, </code><code class="keyword">int</code> <code class="plain">x)</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">push(q.stack1, x);</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number38 index37 alt1">&nbsp;</div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Function to deQueue an item from queue */</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">int</code> <code class="plain">deQueue(Queue q)</code>
    </div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">x;</code></div>
    <div class="line number43 index42 alt2">&nbsp;</div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* If both stacks are empty then error */</code></div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(q.stack1.isEmpty() &amp;&amp; q.stack2.isEmpty()) &#123;</code>
    </div>
    <div class="line number46 index45 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Q is empty"</code><code
            class="plain">);</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.exit(</code><code class="value">0</code><code class="plain">);</code></div>
    <div class="line number48 index47 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number49 index48 alt2">&nbsp;</div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Move elements from stack1 to stack 2 only if</code></div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">stack2 is empty */</code></div>
    <div class="line number52 index51 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(q.stack2.isEmpty()) &#123;</code></div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">(!q.stack1.isEmpty()) &#123;</code></div>
    <div class="line number54 index53 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = pop(q.stack1);</code></div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">push(q.stack2, x);</code></div>
    <div class="line number56 index55 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number57 index56 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number58 index57 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = pop(q.stack2);</code></div>
    <div class="line number59 index58 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">x;</code></div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number61 index60 alt2">&nbsp;</div>
    <div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Driver function to test above functions */</code></div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String args[])</code></div>
    <div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Create a queue with items 1 2 3*/</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Queue q = </code><code class="keyword">new</code> <code class="plain">Queue();</code></div>
    <div class="line number67 index66 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.stack1 = </code><code class="keyword">new</code> <code class="plain">Stack&lt;&gt;();</code>
    </div>
    <div class="line number68 index67 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.stack2 = </code><code class="keyword">new</code> <code class="plain">Stack&lt;&gt;();</code>
    </div>
    <div class="line number69 index68 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">enQueue(q, </code><code class="value">1</code><code class="plain">);</code></div>
    <div class="line number70 index69 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">enQueue(q, </code><code class="value">2</code><code class="plain">);</code></div>
    <div class="line number71 index70 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">enQueue(q, </code><code class="value">3</code><code class="plain">);</code></div>
    <div class="line number72 index71 alt1">&nbsp;</div>
    <div class="line number73 index72 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Dequeue items */</code></div>
    <div class="line number74 index73 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(deQueue(q) + </code><code class="string">" "</code><code
            class="plain">);</code></div>
    <div class="line number75 index74 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(deQueue(q) + </code><code class="string">" "</code><code
            class="plain">);</code></div>
    <div class="line number76 index75 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(deQueue(q) + </code><code class="string">" "</code><code
            class="plain">);</code></div>
    <div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number78 index77 alt1"><code class="plain">&#125;</code></div>
    <div class="line number79 index78 alt2"><code class="comments">// This code is contributed by Sumit Ghosh</code>
    </div>
</div>
                 </div>
             <div id="tab-content-3" class="tab-content"> 
             <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 program to implement Queue using</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># two stacks with costly deQueue()</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">Queue:</code></div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number6 index5 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.s1 </code><code class="keyword">=</code> <code
            class="plain">[]</code></div>
    <div class="line number7 index6 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.s2 </code><code class="keyword">=</code> <code
            class="plain">[]</code></div>
    <div class="line number8 index7 alt1">&nbsp;</div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># EnQueue item to the queue</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">enQueue(</code><code class="color1">self</code><code
            class="plain">, x):</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.s1.append(x)</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># DeQueue item from the queue</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">deQueue(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number15 index14 alt2">&nbsp;</div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># if both the stacks are empty</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="functions">len</code><code class="plain">(</code><code
            class="color1">self</code><code class="plain">.s1) </code><code class="keyword">=</code><code
            class="keyword">=</code> <code class="value">0</code> <code class="keyword">and</code> <code
            class="functions">len</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.s2) </code><code class="keyword">=</code><code class="keyword">=</code> <code
            class="value">0</code><code class="plain">:</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code class="string">"Q is Empty"</code><code
            class="plain">)</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code></div>
    <div class="line number20 index19 alt1">&nbsp;</div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># if s2 is empty and s1 has elements</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">elif</code> <code class="functions">len</code><code class="plain">(</code><code
            class="color1">self</code><code class="plain">.s2) </code><code class="keyword">=</code><code
            class="keyword">=</code> <code class="value">0</code> <code class="keyword">and</code> <code
            class="functions">len</code><code class="plain">(</code><code class="color1">self</code><code
            class="plain">.s1) &gt; </code><code class="value">0</code><code class="plain">:</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="functions">len</code><code class="plain">(</code><code
            class="color1">self</code><code class="plain">.s1):</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.s1.pop()</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.s2.append(temp)</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">self</code><code class="plain">.s2.pop()</code></div>
    <div class="line number27 index26 alt2">&nbsp;</div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="color1">self</code><code class="plain">.s2.pop()</code></div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Driver code</code></div>
    <div class="line number32 index31 alt1"><code class="keyword">if</code> <code class="plain">__name__ </code><code
            class="keyword">=</code><code class="keyword">=</code> <code class="string">'__main__'</code><code
            class="plain">:</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q </code><code class="keyword">=</code> <code class="plain">Queue()</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.enQueue(</code><code class="value">1</code><code class="plain">)</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.enQueue(</code><code class="value">2</code><code class="plain">)</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q.enQueue(</code><code class="value">3</code><code class="plain">)</code></div>
    <div class="line number37 index36 alt2">&nbsp;</div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(q.deQueue())</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(q.deQueue())</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(q.deQueue())</code></div>
    <div class="line number41 index40 alt2">&nbsp;</div>
    <div class="line number42 index41 alt1"><code class="comments"># This code is contributed by Pratyush Kumar</code>
    </div>
</div>
          </div>
          <div id="tab-content-4" class="tab-content">
          <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">/* C Program to implement a queue using two stacks */</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;stdlib.h&gt;</code></div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="comments">/* structure of a stack node */</code></div>
    <div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">sNode &#123;</code>
    </div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">data;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">sNode* next;</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number10 index9 alt1">&nbsp;</div>
    <div class="line number11 index10 alt2"><code class="comments">/* Function to push an item to stack*/</code></div>
    <div class="line number12 index11 alt1"><code class="keyword bold">void</code> <code class="plain">push(</code><code
            class="keyword bold">struct</code> <code class="plain">sNode** top_ref, </code><code
            class="color1 bold">int</code> <code class="plain">new_data);</code></div>
    <div class="line number13 index12 alt2">&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="comments">/* Function to pop an item from stack*/</code></div>
    <div class="line number15 index14 alt2"><code class="color1 bold">int</code> <code class="plain">pop(</code><code
            class="keyword bold">struct</code> <code class="plain">sNode** top_ref);</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="comments">/* structure of queue having two stacks */</code>
    </div>
    <div class="line number18 index17 alt1"><code class="keyword bold">struct</code> <code class="plain">queue &#123;</code>
    </div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">sNode* stack1;</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">sNode* stack2;</code></div>
    <div class="line number21 index20 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number22 index21 alt1">&nbsp;</div>
    <div class="line number23 index22 alt2"><code class="comments">/* Function to enqueue an item to queue */</code>
    </div>
    <div class="line number24 index23 alt1"><code class="keyword bold">void</code> <code
            class="plain">enQueue(</code><code class="keyword bold">struct</code> <code
            class="plain">queue* q, </code><code class="color1 bold">int</code> <code class="plain">x)</code></div>
    <div class="line number25 index24 alt2"><code class="plain">&#123;</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">push(&amp;q-&gt;stack1, x);</code></div>
    <div class="line number27 index26 alt2"><code class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code class="comments">/* Function to deQueue an item from queue */</code>
    </div>
    <div class="line number30 index29 alt1"><code class="color1 bold">int</code> <code
            class="plain">deQueue(</code><code class="keyword bold">struct</code> <code class="plain">queue* q)</code>
    </div>
    <div class="line number31 index30 alt2"><code class="plain">&#123;</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">x;</code></div>
    <div class="line number33 index32 alt2">&nbsp;</div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* If both stacks are empty then error */</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code
            class="plain">(q-&gt;stack1 == NULL &amp;&amp; q-&gt;stack2 == NULL) &#123;</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"Q is empty"</code><code class="plain">);</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">getchar</code><code class="plain">();</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">exit</code><code class="plain">(0);</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number40 index39 alt1">&nbsp;</div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Move elements from stack1 to stack 2 only if</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">stack2 is empty */</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(q-&gt;stack2 == NULL) &#123;</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(q-&gt;stack1 != NULL) &#123;</code></div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = pop(&amp;q-&gt;stack1);</code></div>
    <div class="line number46 index45 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">push(&amp;q-&gt;stack2, x);</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number49 index48 alt2">&nbsp;</div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">x = pop(&amp;q-&gt;stack2);</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">x;</code></div>
    <div class="line number52 index51 alt1"><code class="plain">&#125;</code></div>
    <div class="line number53 index52 alt2">&nbsp;</div>
    <div class="line number54 index53 alt1"><code class="comments">/* Function to push an item to stack*/</code></div>
    <div class="line number55 index54 alt2"><code class="keyword bold">void</code> <code class="plain">push(</code><code
            class="keyword bold">struct</code> <code class="plain">sNode** top_ref, </code><code
            class="color1 bold">int</code> <code class="plain">new_data)</code></div>
    <div class="line number56 index55 alt1"><code class="plain">&#123;</code></div>
    <div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* allocate node */</code></div>
    <div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">sNode* new_node = (</code><code
            class="keyword bold">struct</code> <code class="plain">sNode*)</code><code
            class="functions bold">malloc</code><code class="plain">(</code><code
            class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
            class="plain">sNode));</code></div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(new_node == NULL) &#123;</code></div>
    <div class="line number60 index59 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"Stack overflow \n"</code><code class="plain">);</code></div>
    <div class="line number61 index60 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">getchar</code><code class="plain">();</code></div>
    <div class="line number62 index61 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">exit</code><code class="plain">(0);</code></div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number64 index63 alt1">&nbsp;</div>
    <div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* put in the data */</code></div>
    <div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node-&gt;data = new_data;</code></div>
    <div class="line number67 index66 alt2">&nbsp;</div>
    <div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* link the old list off the new node */</code></div>
    <div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node-&gt;next = (*top_ref);</code></div>
    <div class="line number70 index69 alt1">&nbsp;</div>
    <div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* move the head to point to the new node */</code></div>
    <div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">(*top_ref) = new_node;</code></div>
    <div class="line number73 index72 alt2"><code class="plain">&#125;</code></div>
    <div class="line number74 index73 alt1">&nbsp;</div>
    <div class="line number75 index74 alt2"><code class="comments">/* Function to pop an item from stack*/</code></div>
    <div class="line number76 index75 alt1"><code class="color1 bold">int</code> <code class="plain">pop(</code><code
            class="keyword bold">struct</code> <code class="plain">sNode** top_ref)</code></div>
    <div class="line number77 index76 alt2"><code class="plain">&#123;</code></div>
    <div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">res;</code></div>
    <div class="line number79 index78 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">sNode* top;</code></div>
    <div class="line number80 index79 alt1">&nbsp;</div>
    <div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/*If stack is empty then error */</code></div>
    <div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(*top_ref == NULL) &#123;</code></div>
    <div class="line number83 index82 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"Stack underflow \n"</code><code class="plain">);</code></div>
    <div class="line number84 index83 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">getchar</code><code class="plain">();</code></div>
    <div class="line number85 index84 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">exit</code><code class="plain">(0);</code></div>
    <div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code> <code class="plain">&#123;</code></div>
    <div class="line number88 index87 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">top = *top_ref;</code></div>
    <div class="line number89 index88 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">res = top-&gt;data;</code></div>
    <div class="line number90 index89 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">*top_ref = top-&gt;next;</code></div>
    <div class="line number91 index90 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">free</code><code class="plain">(top);</code></div>
    <div class="line number92 index91 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">res;</code></div>
    <div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number94 index93 alt1"><code class="plain">&#125;</code></div>
    <div class="line number95 index94 alt2">&nbsp;</div>
    <div class="line number96 index95 alt1"><code class="comments">/* Driver function to test anove functions */</code>
    </div>
    <div class="line number97 index96 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number98 index97 alt1"><code class="plain">&#123;</code></div>
    <div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Create a queue with items 1 2 3*/</code></div>
    <div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">queue* q = (</code><code
            class="keyword bold">struct</code> <code class="plain">queue*)</code><code
            class="functions bold">malloc</code><code class="plain">(</code><code
            class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
            class="plain">queue));</code></div>
    <div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q-&gt;stack1 = NULL;</code></div>
    <div class="line number102 index101 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">q-&gt;stack2 = NULL;</code></div>
    <div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">enQueue(q, 1);</code></div>
    <div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">enQueue(q, 2);</code></div>
    <div class="line number105 index104 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">enQueue(q, 3);</code></div>
    <div class="line number106 index105 alt1">&nbsp;</div>
    <div class="line number107 index106 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Dequeue items */</code></div>
    <div class="line number108 index107 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
            class="plain">, deQueue(q));</code></div>
    <div class="line number109 index108 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
            class="plain">, deQueue(q));</code></div>
    <div class="line number110 index109 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
            class="plain">, deQueue(q));</code></div>
    <div class="line number111 index110 alt2">&nbsp;</div>
    <div class="line number112 index111 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number113 index112 alt2"><code class="plain">&#125;</code></div>
</div>
              </div>
            </div>
         </div>
<br /> <br /> <br /> <br /> <br />
    </div>
    )
}

export default Flpkrt14
